import Chart, { Label, Export, Series, CommonSeriesSettings, Format, ValueAxis, Legend, Tooltip } from "devextreme-react/chart"

interface BarChartSeries {
    valueField: string,
    name: string
    visible?: boolean
}

interface BarChartProps {
    data: any[]
    title: string
    exportEnabled?: boolean
    series?: BarChartSeries[]
    seriesType?: "bar"|"stackedbar"
    tooltipEnabled?: boolean
    customizeTooltip?: (arg: { seriesName: string, valueText: string, argumentText: string }) => { text: string }
}

export const BarChart: React.FC<BarChartProps> = (props) => {
    return (
        <Chart
            id="chart"
            dataSource={props.data}
            palette="Harmony Light"
            title={props.title}>
            <CommonSeriesSettings
                argumentField="scheduledOn"
                type={`${props.seriesType ?? "bar"}`}
                hoverMode="allArgumentPoints"
                selectionMode="allArgumentPoints">
                <Label visible={true}>
                    <Format type="fixedPoint" precision={0} />
                </Label>
            </CommonSeriesSettings>
            <ValueAxis allowDecimals={false}>
                <Label visible={true} />
            </ValueAxis>
            {props.series?.map((s, index) => (
                <Series valueField={s.valueField} name={s.name} key={index} visible={s.visible === undefined ? true : s.visible} />
            ))}
            <Legend verticalAlignment="bottom" horizontalAlignment="center" />
            <Tooltip enabled={props.tooltipEnabled} location="edge" customizeTooltip={props.customizeTooltip} />
            <Export enabled={props.exportEnabled ?? false} />
        </Chart>
    )
}
